import React, { useMemo, useState } from 'react';
import { formatStatusSummary } from '../../utils/year2SquadSetup';
import './year2SquadCreator.css';

export default function Year2SchoolDashboard({ schools, loading, onSelectSchool }) {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return schools;
    return schools.filter((school) => (school.school_name || '').toLowerCase().includes(q));
  }, [schools, query]);

  if (loading) {
    return (
      <div className="placeholder-card">
        <p>Loading Year 2 cohorts…</p>
      </div>
    );
  }

  if (schools.length === 0) {
    return (
      <div className="placeholder-card">
        <h2>No Year 2 cohorts available.</h2>
        <p>Mark existing cohorts as Year 2 before creating squads.</p>
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="Search schools…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="wizard-search-input"
          style={{ maxWidth: '480px', width: '100%' }}
        />
      </div>

      <div className="year2-school-grid">
        {filtered.map((school) => {
          const statusText = formatStatusSummary(school.status_summary);
          return (
            <button
              key={school.school_id}
              type="button"
              className="year2-school-card"
              onClick={() => onSelectSchool(school)}
            >
              <div className="year2-card-header">
                <div>
                  <h3 className="year2-card-title">{school.school_name}</h3>
                  <p style={{ margin: 0, fontSize: '12px', color: 'var(--text-muted)' }}>
                    Year 2 programme school
                  </p>
                </div>
                <span className="year2-card-icon" aria-hidden>🏫</span>
              </div>
              <div className="year2-metric-row">
                <div className="year2-metric-chip">
                  <div className="year2-metric-value">{school.cohort_count}</div>
                  <div className="year2-metric-label">Year 2 cohorts</div>
                </div>
                <div className="year2-metric-chip" style={{ flex: '1 1 160px' }}>
                  <div className="year2-metric-value" style={{ fontSize: '13px', fontWeight: 600, lineHeight: 1.4 }}>
                    {statusText}
                  </div>
                  <div className="year2-metric-label">Setup status</div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}